<template>    
  <div>
    <v-main style="padding: 0px 0px 0px 56px;">
      <v-container fluid>
        <v-row class="mb-1">
          <v-col
            cols="12"
            xs="12"
            md="6"
          >
            <div class="text-h4">
              {{ $t("creditLimit") }}
            </div>
          </v-col>
        </v-row>
        <v-skeleton-loader
          v-if="loading"
          :loading="loading"
          transition="fade-transition"
          type="card"
        />
        <v-card v-show="loaded">
          <!-- <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter" v-if="credito.isTigre">
                  <v-row dense>
                    <v-col cols="12" md="1" class="mx-md-6 mx-lg-0">
                      <div
                        class="d-flex align-baseline"
                        :class="!$vuetify.breakpoint.xsOnly ? 'justify-space-around' : 'mb-6'"
                      >
                        <div class="mx-md-1 mx-lg-2 mr-2" style="margin-top: 0.7rem;">
                          <span>Filtros</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                      <v-text-field
                        v-model="filters.CLIENTE"
                        label="FEIN"
                        outlined
                        dense
                        clearable
                        type="number"
                      />
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-btn
                        depressed
                        color="#D8D8D8"
                        :block="$vuetify.breakpoint.xsOnly"
                        type="submit"
                      >
                        <v-icon> mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider />
                </v-form>
              </v-col>
            </v-row>
          </v-container> -->



          <v-container>
            <v-row class="pa-1">
              <v-col>
                <div class="credit-contaienr">
                  <div class="credit-label-container">
                    <strong class="credit-percentual" :style="{width: credito.percentual + '%'}">
                      <span>{{ credito.percentualConsumido }}%</span>
                    </strong>
                    <strong v-if="credito.excedidoPercentual" class="credit-exceeded" :style="{width: (100 - credito.percentual) + '%'}">
                      <span>{{ credito.excedidoPercentual }}%</span>
                    </strong>
                  </div>
                  <v-progress-linear
                    class="color-white-tigre"
                    color="info"
                    :background-color="credito.excedidoPercentual ? 'red' : 'grey lighten-2'"
                    height="25"
                    :value="credito.percentual"
                  ></v-progress-linear>
                </div>
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <AppDetailLabel
                :title="$t('total')"
                :value="currency(credito.limiteTotal, credito.moedaPais)"
                :md="4"
                :hidden-divider="true"
              />
              <AppDetailLabel
                :title="$t('available')"
                :value="currency(credito.limiteDisponivel, credito.moedaPais)"
                :md="4"
                :hidden-divider="true"
              />
              <v-col :md="4">
                <AppDetailLabel
                    v-if="credito"
                    :title="$t('exceeded')"
                    :value="currency(credito.limiteExcedido, credito.moedaPais)"
                    :hidden-divider="true"
                />
                <AppDetailLabel
                    :title="$t('consumed')"
                    :value="getConsumed()"
                    :hidden-divider="true"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row class="mt-1">
          <v-col
            v-show="!loading"
            cols="12"
            xs="12"
            md="12"
            class="align-right"
          >
            <v-chip
              class="ma-2 mr-0"
              label
              small
            >
              {{ $t("consultationUpdatedOn") }} {{ listDate }}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import AppDetailLabel from "../../components/generic/AppDetailLabel";
import { currency } from "../../helpers/filter";
import EventBus from "../../plugins/event-bus";
import mixinFilters from "@/mixins/mixinFilter";
import utils from '@/utils';
import axios from 'axios';
import config from '@/config';

const route = "credito";
const routerFabrimar = "creditoFabrimar"
const appStore = "AppCreditoStore"; 

export default {
  mixins: [mixinFilters],
  components: {
    AppDetailLabel
  },
  data () {
    return {
      loading: true,
      loaded: false,
      dialog: false,
      consumed: '',
      filters: {
        CLIENTE: ""
      },
      thisPage: 'limite_credito'
    }
  },
  computed: {
    ...mapState(`${appStore}`, {
      credito: state => state[route],
      creditoFabrimar:state => state[routerFabrimar],
      listDate: (state) => state[`${route}Date`]
    })
  },
  created() {
    EventBus.$on("change::isLoading", (loading) => {
      this.loading = loading;
      this.loaded = !loading;
    });
    this.saveAccessPage();
  },
  mounted() {
    this.$store.commit(`${appStore}/cleanState`);
    this.$store.dispatch(`${appStore}/getById`);
  },
  methods: {
    currency,
    ...mapActions([`${appStore}/getById`]),
    pageForm(){
      this.$router.push({
        path: `limite-credito`
      });
    },
    getConsumed()
    {
      return `${currency(this.credito.consumido, this.credito.moedaPais)}
          ${currency(this.credito.vencer, this.credito.moedaPais)} (${this.$i18n.t('porVencer')})
          ${currency(this.credito.limiteVencido, this.credito.moedaPais)} (${this.$i18n.t('vencido')})`
    },
    submitFilter() {
      this.$store.commit(`${appStore}/cleanState`);
      this.$store.dispatch(`${appStore}/getByFin`, { fin: this.filters.CLIENTE });
    },
    async saveAccessPage(){
      let country = utils.loadCountry();
      let userid = utils.loadUserId();
      let token = utils.loadToken();

      axios.post(`${config.VUE_APP_API_URL}venusa/saveAccessPage`, { UNIDADE_PAIS: country, USERID: userid, THISPAGE: this.thisPage, TOKEN: token });
    }
  }
}
</script>